import { ROUTER_ADMIN_CREDENTIAL_ACTION } from '../types/router/router-admin-credentials.type';
import { ROUTER_ADMIN_PASSWORD_UPDATE_STATUS } from '../types/enums/router-admin-password-update-status.enum';

export const ROUTER_ADMIN_CREDENTIAL_HISTORY_LIMIT = 10;

export const getCredentialHistoryStatusLabel = (
  action: ROUTER_ADMIN_CREDENTIAL_ACTION,
  status: ROUTER_ADMIN_PASSWORD_UPDATE_STATUS | null
): string => {
  if (action === ROUTER_ADMIN_CREDENTIAL_ACTION.GENERATED) {
    return 'Portal only';
  }

  if (action === ROUTER_ADMIN_CREDENTIAL_ACTION.SYNCED_FROM_PROVIDER) {
    if (status === ROUTER_ADMIN_PASSWORD_UPDATE_STATUS.COMPLETED) {
      return 'Synced from provider';
    }
    return status || '-';
  }

  if (action === ROUTER_ADMIN_CREDENTIAL_ACTION.PUSHED) {
    switch (status) {
      case ROUTER_ADMIN_PASSWORD_UPDATE_STATUS.PENDING:
      case ROUTER_ADMIN_PASSWORD_UPDATE_STATUS.RUNNING:
        return 'Sent — awaiting device';
      case ROUTER_ADMIN_PASSWORD_UPDATE_STATUS.COMPLETED:
        return 'Confirmed on device';
      case ROUTER_ADMIN_PASSWORD_UPDATE_STATUS.FAILED:
        return 'Push failed';
      case ROUTER_ADMIN_PASSWORD_UPDATE_STATUS.UNKNOWN:
        return 'Status unknown';
      default:
        return status || '-';
    }
  }

  return status || '-';
};
